import { Tooltip } from '@mui/material'
import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { Colors } from 'src/assets/colors/Colors'
import SelectFormVirtualize from 'src/components/ComponentesFormularios/SelectFormVirtualize'
import { classResponsiveFormDoubleWidthHeader, classResponsiveFormDoubleWidthHeaderWithoutPaddingX, ERRORFIELDREQUIRED } from 'src/data/ConstantForm'
import { GlobalConstants } from 'src/data/GlobalConstants'
import { alertQuestionService } from 'src/services/alertQuestionService'
import { clientesService } from 'src/services/apiClientes'
import { modalCRUDService } from 'src/services/modalCRUDService'

const FormDenegado = ({properties}) => {

    const { tableRef, id = null } = properties
    console.log('id', id)
    const authState= useSelector( state => state.auth)
    const generalServices = useSelector(state => state.generalServices)
    const { idUsuario } = authState
    const dispatch = useDispatch()

    const methods = useForm({
        defaultValues: {}
    })
    const { control, getValues, setValue, handleSubmit, formState: { errors } } = methods

    const onSuccessSubmit = (data) => {
        if(data.motivos == '' || data.motivos == null){
            dispatch({
                type: 'setStateAlert',
                alert: {type: GlobalConstants.alertWarning, message: `Debes seleccionar un motivo`}
            })
        }else{
            let auxData = []

            if(id == null){

                const isSelected = tableRef.current.api.getSelectedRows()    
                auxData = isSelected.map(item => item.id)

            }else{
                auxData.push(id)
            }

            alertQuestionService.showAlert({
                title: 'Denegar Solicitudes', question: '¿Estás seguro que desea denegar las solicitudes?', message: 'Si desea denegar las solicitudes seleccionadas dar clic en el botón Aceptar',
                datos: null,
                actionBtnAceptar: async() => {
                    alertQuestionService.clear();
                    try{
                        const response = await clientesService.setEstadoClientesManual(auxData, '104', idUsuario);
                        const {status, msg, data: datos} = response
                        
                        if(status){

                            const res = await clientesService.setObservacionSolicitudCliente({ identificadores: auxData, observacion: data.motivos.text})

                            const {status: statusObs, msg: msgObs, data: datosObs} = res 

                            if(statusObs){
                                modalCRUDService.clear()
                                dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertSuccess, message: msg}})
                                dispatch({
                                    type: 'setStateGeneralServices', generalServices: {
                                        ...generalServices,
                                        stateFlag: !generalServices?.stateFlag,
                                    }
                                })
                            }else{
                                dispatch({
                                    type: 'setStateAlert',
                                    alert: {type: GlobalConstants.alertError, message: msg}
                                })
                            }
                        }else{
                            dispatch({
                                type: 'setStateAlert',
                                alert: {type: GlobalConstants.alertError, message: `Comunicarse con soporte`}
                            })
                        }
                    }catch(e){
                        dispatch({
                            type: 'setStateAlert',
                            alert: {type: GlobalConstants.alertError, message: `Comunicarse con soporte`}
                        })
                    }
                },
                actionBtnCancelar: () => { alertQuestionService.clear() },
                type: GlobalConstants.alertInfo

            })      
        }
    }

    const onErrorSubmit = () => { }

  return (
    <FormProvider {...methods}>
        <div className='d-flex align-items-center justify-content-between'> 
            <div className='w-100'>
                <h5>Selecciona el motivo de la denegación.</h5>
                <SelectFormVirtualize inputProps={{control}} disabled={false} identificador="motivos" label="" required={false}
                                  className={`w-75 mt-1`} options={generalServices?.arrMotivos}
                                  customError={errors.motivo ? ERRORFIELDREQUIRED : null}/>
            </div>
            <div className="d-flex justify-content-start align-items-start" style={{height: "5.5rem"}}>
              <Tooltip title="Guardar" aria-label="guardar">
                <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                  className="icon-container-actions d-flex">
                  <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                  <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-check fa-2x"/>
                </a>
              </Tooltip>
            </div>
        </div>
    </FormProvider>
  )
}

export default FormDenegado